import inView from './utilites/inView.js';

export  function counterUp(element, options = {}) {
    const settings = Object.assign({
        time: 400,
        delay: 10
    }, options);

    function startCounter(el) {
        let nums = [];
        let divisions = settings.time / settings.delay;
        let value = el.querySelector('.target').dataset.counter;

        value = value.replace('k', '');
        value = value.replace('m', '');
        const isInt = /^[0-9]+$/.test(value);
        const isFloat = /^[0-9]+\.[0-9]+$/.test(value);
        const decimalPlaces = isFloat ? (value.split('.')[1] || []).length : 0;

        for (let i = divisions; i >= 1; i--) {
            let newVal = (value / divisions) * i;

            if (isInt){ newVal = parseInt(newVal, 10); }
            if (isFloat){ newVal = newVal.toFixed(decimalPlaces); }

            nums.unshift(newVal);
        }

        el.querySelector('.target').textContent = '';

        function updateCounter() {
            if( el.querySelector('.target').classList.contains('running') ) {
                return;
            }
            el.querySelector('.target').textContent = nums.shift();
            if (nums.length) {
                setTimeout(updateCounter, settings.delay);
            }
        }

        setTimeout(updateCounter, settings.delay);
    }

    inView(element, {}, {
        onEnter: () => {
            if( ! element.classList.contains('is-init') ) {
                startCounter(element);
                element.classList.add('is-init');
            }
        }
    });
}
export default function counter() {
    document.querySelectorAll('.tz-counter').forEach(el => {
        counterUp(el, { time: 1000, delay: 16 });
    });
}